export const monitoring_general = {
  index: {
    title: 'Pemantauan'
  },

  tooltip: {
    index: 'Pemantauan tersedia untuk kampanye aktif'
  }
};